import { WidgetSizeT } from "../../localTypes/WidgetSizeT";

export function widgetAddSizeGreaterOrEqualTo(
  left: WidgetSizeT,
  right: WidgetSizeT
) {
  return left.w >= right.w && left.h >= right.h;
}
